import { Carousel } from "shared/components/atoms/Carousel";
import { H2 } from "components/atoms/H2";
import { useFavorite } from "features/shared/hooks/useFavorite";
import { useRouter } from "next/router";
import { useTagFortuneList, useTagTelFortuneList } from "repositories/hooks";
import { Fortune, Tag, TelFortune } from "shared/types";
import { Paths } from "utils/routes";
import Link from "next/link";
import { menuHelper } from "../utils/menuHelper";
import { MenuGallelyCard } from "shared/features/Menu/components/MenuGallelyCard";

const getTagFortuneListParams = {
  orderBy: "popular" as const,
  limit: 5,
  page: 1,
};

interface Props {
  tag: Tag;
}

export const TagMenu = ({ tag }: Props) => {
  const { fortunes, isLoading: isLoadingFortunes } = useTagFortuneList({
    tagId: tag.id,
    ...getTagFortuneListParams,
  });
  const { telFortunes, isLoading: isLoadingTelFortunes } = useTagTelFortuneList(
    {
      tagId: tag.id,
      ...getTagFortuneListParams,
    }
  );

  const { onClickFavorite } = useFavorite();
  const { push } = useRouter();

  const isLoading = isLoadingFortunes || isLoadingTelFortunes;

  if (isLoading) return null;

  const renderMenu = (fortune: Fortune | TelFortune) => {
    const { menuPagePath } = menuHelper(fortune);
    return (
      <Link href={menuPagePath}>
        <a>
          <MenuGallelyCard menu={fortune} onClickFav={onClickFavorite} />
        </a>
      </Link>
    );
  };

  return (
    <>
      <H2 tw="px-5" readMore onClick={() => push(Paths.tags.show(tag.id))}>
        {tag.name}に関する人気メニュー
      </H2>
      <Carousel data={[...fortunes, ...telFortunes]} renderItem={renderMenu} />
    </>
  );
};
